import * as yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";

export function validateEmail(email: string): boolean {
  return yup
    .string()
    .email()
    .ensure()
    .isValidSync(email);
}

export function validatePhone(phone: string): boolean {
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parse(phone, "HK");
    return phoneUtil.isValidNumber(number);
  } catch (e) {
    // Error message (e.message):
    // "The string supplied did not seem to be a phone number"
    // "Invalid country calling code"
    // "The string supplied is too long to be a phone number"
    return false;
  }
}
